(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('[data-product-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-product-gallery]');
    const main = gallery && gallery.querySelector('[data-product-gallery-main]');
    if (!main) return;
    main.src = thumb.dataset.gallerySrc;
    main.alt = thumb.dataset.galleryAlt;
    gallery.querySelectorAll('[data-product-gallery-thumb]').forEach(function (button) {
      button.setAttribute('aria-pressed', button === thumb ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
